<template>
    <div class="Public-Slider">
        <i class="fa fa-star-half-empty"></i>
        <div class="MoveTop" v-on:click="MoveTop">
            <i class="fa fa-angle-double-up"></i>
        </div>
        <div class="Language" :title="Slider.Language.Title" v-on:click="SwitchLanguage"><i
            class="fa fa-language"></i>{{ Slider.Language.Content }}
        </div>
    </div>
</template>

<script>
export default {
    name: "PublicSlider",
    methods: {
        MoveTop: function () {//返回网页顶部
            window.scrollTo(0, 0);
        },
        SwitchLanguage: function () {//将文本切换为另一语言
            this.$store.commit("SWITCHLANGUAGE");
            this.$store.commit("NOTICE", "Language")
        },
    },
    computed: {
        Slider: function () {
            return this.$store.state.LANGUAGECONTENT.Slider;
        }
    }
}
</script>